import { render, staticRenderFns } from "./PropPlayer.vue?vue&type=template&id=2c6ce52a&scoped=true&"
import script from "./PropPlayer.vue?vue&type=script&lang=js&"
export * from "./PropPlayer.vue?vue&type=script&lang=js&"
import style0 from "./PropPlayer.vue?vue&type=style&index=0&id=2c6ce52a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6ce52a",
  null
  
)

export default component.exports